import React from "react";

import { Box } from "../elements";
import { InputField } from "../v3";

export const AddYard = ({ inputData, handleChange }) => {
  return (
    <>
      <Box className="fl gap-2">
        <InputField
          label="Yard Name"
          name="yardName"
          value={inputData.yardName}
          onChange={handleChange}
          style={{ width: "100%", marginBottom: 3 }}
        />
        <InputField
          label="Yard Location"
          name="yardLocation"
          value={inputData.yardLocation}
          onChange={handleChange}
          style={{ width: "100%", marginBottom: 3 }}
        />
      </Box>
    </>
  );
};
